import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AvatarComponent } from '@coreui/angular-pro';
import { BaseService } from '../../../base.service';

@Component({
    selector: 'app-autoavatar',
    templateUrl: './autoavatar.component.html',
    standalone: true,
    imports: [AvatarComponent,CommonModule, ],
    styleUrls: ['./autoavatar.component.css']
})
export class AutoavatarComponent {
    @Input() UserData:any;
    @Input() Header : boolean = true;
    Colors: { [key: number]: string } = {
        0: 'primary',
        1: 'secondary',
        2: 'success',
        3: 'danger',
        4: 'warning',
        5: 'info'
    };
    Color: string;
    constructor (
        public BaseService: BaseService,
    ) {
        this.Color = this.generateRandomColor();
    }
    extractInitials(name: string): string {
        const nameParts = name.split(' ');
        const initials = nameParts.map(part => part.charAt(0)).join('').substring(0, 2);
        return initials.toUpperCase();
    }

    generateRandomColor(): string {
        const randomColor = Math.floor(Math.random() * 6);
        return this.Colors[randomColor];
    }
    
}